var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDocs(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 18.9583H6.66667C3.625 18.9583 1.875 17.2083 1.875 14.1667V5.83332C1.875 2.79166 3.625 1.04166 6.66667 1.04166H13.3333C16.375 1.04166 18.125 2.79166 18.125 5.83332V14.1667C18.125 17.2083 16.375 18.9583 13.3333 18.9583ZM6.66667 2.29166C4.28333 2.29166 3.125 3.44999 3.125 5.83332V14.1667C3.125 16.55 4.28333 17.7083 6.66667 17.7083H13.3333C15.7167 17.7083 16.875 16.55 16.875 14.1667V5.83332C16.875 3.44999 15.7167 2.29166 13.3333 2.29166H6.66667Z",
    fill: "#514EF3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4166 7.70833H13.7499C12.4833 7.70833 11.4583 6.68333 11.4583 5.41667V3.75C11.4583 3.40833 11.7416 3.125 12.0833 3.125C12.4249 3.125 12.7083 3.40833 12.7083 3.75V5.41667C12.7083 5.99167 13.1749 6.45833 13.7499 6.45833H15.4166C15.7583 6.45833 16.0416 6.74167 16.0416 7.08333C16.0416 7.425 15.7583 7.70833 15.4166 7.70833Z",
    fill: "#514EF3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0001 11.4583H6.66675C6.32508 11.4583 6.04175 11.175 6.04175 10.8333C6.04175 10.4917 6.32508 10.2083 6.66675 10.2083H10.0001C10.3417 10.2083 10.6251 10.4917 10.6251 10.8333C10.6251 11.175 10.3417 11.4583 10.0001 11.4583Z",
    fill: "#514EF3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3334 14.7917H6.66675C6.32508 14.7917 6.04175 14.5083 6.04175 14.1667C6.04175 13.825 6.32508 13.5417 6.66675 13.5417H13.3334C13.6751 13.5417 13.9584 13.825 13.9584 14.1667C13.9584 14.5083 13.6751 14.7917 13.3334 14.7917Z",
    fill: "#514EF3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocs);
export default __webpack_public_path__ + "static/media/docs.86e9092a5b24a76e40a447a752c52443.svg";
export { ForwardRef as ReactComponent };